import React from "react";
import { Link } from "react-router-dom";

const ButtonMailto = ({ mailto, label, icon }) => {
    return (
        <Link
            to='#'
            onClick={(e) => {
                window.location = mailto;
                e.preventDefault();
            }}
        >
            {label}
            <span className="icon">{icon}</span>

        </Link>
    );
};

export default ButtonMailto;